var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 9.20104H10.799V0.798716C10.799 0.357439 10.441 0 9.99975 0C9.55847 0 9.20104 0.357439 9.20104 0.798716V9.20104H0.798716C0.357439 9.20104 0 9.55847 0 9.99975C0 10.441 0.357439 10.799 0.798716 10.799H9.20104V19.2008C9.20104 19.6421 9.55847 20 9.99975 20C10.441 20 10.799 19.6421 10.799 19.2008V10.799H19.2008C19.6421 10.799 20 10.441 20 9.99975C20 9.55847 19.6421 9.20104 19.2008 9.20104Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/plus-black.e666a6eac70f9946361d63a279f0c247.svg";
export { ForwardRef as ReactComponent };